// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"415f2957","977":"782f225d"}[chunkId] + ".chunk.js";
};